import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ISearchItem } from '../../columns-chooser-tree.component';
import { TreeNode } from '../../tree-structure';

@Component({
  selector: 'iv-live-columns-chooser-search-item',
  templateUrl: './columns-chooser-search-item.component.html',
  styleUrls: ['./columns-chooser-search-item.component.scss']
})
export class ColumnsChooserSearchItemComponent implements OnInit {
  @Input() data: ISearchItem;
  @Input() checkbox: boolean = false;
  @Output() onCheckboxChecked = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

  public onChecked(e: boolean): void {
    this.onCheckboxChecked.emit(e)
  }
}
